export enum TwoFactorStatus {
  CONFIRMED = 'confirmed',
  EXPIRED = 'expired',
  NOT_CONFIRMED = 'email_send',
}

export default TwoFactorStatus;